/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { BrandColors } from '@blend/enterprise-components';
import { Column } from 'react-table';
import { mapValues, keyBy, camelCase, pick } from '@utils/lodash';

const TABLE_HEADER_HEIGHT = 54;

export const getStyles = (tableConfigs: Column<any>[]) =>
  StyleSheet.create({
    firstColumnIndent: {
      paddingLeft: 40,
    },
    footerElement: {
      display: 'flex',
      marginLeft: 5,
    },
    footerInnerContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    innerCellWrapper: {
      alignItems: 'center',
      display: 'flex',
      height: 54,
      width: '100%',
    },
    navLink: {
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      height: '100%',
    },
    pipelineTableContainer: {
      flexGrow: 1,
      overflowY: 'auto',
      minHeight: TABLE_HEADER_HEIGHT,
      marginBottom: 65,
    },
    pipelineTableFooter: {
      alignItems: 'center',
      display: 'flex',
      flexBasis: `100px`,
      flexGrow: 0,
      flexShrink: 0,
      justifyContent: 'flex-end',
      padding: `0px 32px`,
    },
    tableBody: {
      width: '100%',
      minWidth: '1300px',
      overflowX: 'auto',
    },
    tableHeader: {
      backgroundColor: 'white',
      position: 'sticky',
      top: 0,
    },
    tableRowBase: {
      height: 54,
    },
    clickableTableRow: {
      cursor: 'pointer',
      borderLeft: `4px solid transparent`,
      ':hover': {
        backgroundColor: BrandColors.CLOUD_30,
        borderLeftColor: BrandColors.NIGHT_60,
      },
    },
    tableRowEven: {
      backgroundColor: BrandColors.BACKGROUND_GREY,
    },
    tableRowOdd: {
      backgroundColor: BrandColors.WHITE,
    },
    ...mapValues(
      keyBy(tableConfigs, ({ id }) => camelCase(id)),
      config => pick(config, 'width'),
    ),
    buttonStyle: {
      position: 'relative',
      height: 28,
      padding: 12,
      backgroundColor: BrandColors.WHITE,
      color: BrandColors.NIGHT,
      border: `1px solid ${BrandColors.CLOUD_50}`,
    },
  });
